import AgentComponent from './agent'
export default AgentComponent
